<template>
  <div class="imgBlock" :class="alarming ? 'imgBlockAni' : ''" @mouseover="mouseOver" @mouseleave="mouseleave">
    <t-image class="imgNormal" style="width: 100%; height: 100%;background: none"
      :src="option.attribute.img ? fileUrl + option.attribute.img : require('@/assets/custom/imgQuota/quota.svg')"
      fit="fill" />
    <t-image class="imgHover" style="width: 100%; height: 100%;background: none"
      :src="option.attribute.activeImg ? fileUrl + option.attribute.activeImg : require('@/assets/custom/imgQuota/quota_active.svg')"
      fit="fill" />
  </div>
</template>

<script>
import { fileUrl } from '/env'
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { compareByOperator } from "@/utils/threshold-compare";
export default {
  name: "cpt-img-quota",
  props: {
    width: Number,
    height: Number,
    option: Object,
    current: Object
  },
  data() {
    return {
      fileUrl,
      cptData: {},
      uuid: null,
      alarming: true,
      newData: "",
      jsFunFlag: false,
    }
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.globalDataReload) attr.globalDataReload = [0]

    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm) {
      pollingRefresh(this.uuid, cptDataForm, () => { this.loadData(cptDataForm) })
    },
    loadData(cptDataForm) {
      const that = this;
      getDataJson(cptDataForm, '', (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)
        // that.cptData = res;
        // const attr = that.option.attribute
        // if(attr.alarmConfig?.threshold){//告警判断
        //   that.alarming = compareByOperator(attr.alarmConfig.operator,that.cptData.value,attr.alarmConfig.threshold)
        // }
      })
    },
    processData(cptDataForm, res, jsFunFlag) {
      const that = this;
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) { // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = { ...res[0] };
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            // console.log(newres,'新数组');
            this.cptData = newres[0];
          }
        } else { // 如果配置了转换脚本
          this.cptData = res;
        }
      } else { // 不是数据集类型，是静态数据
        this.cptData = res;
      }
      const attr = that.option.attribute
      if (attr.alarmConfig?.threshold) {//告警判断
        that.alarming = compareByOperator(attr.alarmConfig.operator, that.cptData.value, attr.alarmConfig.threshold)
      }
    },
    mouseOver() {
      this.$emit("clickHandler", this.option.interaction, 'default', this.cptData.value)
    },
    mouseleave() {
      let interaction = JSON.parse(JSON.stringify(this.option.interaction));
      //鼠标移开时交换显示和隐藏的对象
      [interaction.objMap.default.show, interaction.objMap.default.hidden] = [interaction.objMap.default.hidden, interaction.objMap.default.show]
      this.$emit("clickHandler", interaction, 'default', this.cptData.value)
    }
  }
}
</script>

<style scoped>
@keyframes blink {
  to {
    filter: invert(100%);
  }
}

.imgHover {
  display: none
}

.imgBlock {
  width: 100%;
  height: 100%;
  position: relative;
}

.imgBlockAni {
  animation: blink 1s infinite linear
}

.imgBlock:hover .imgNormal {
  display: none
}

.imgBlock:hover .imgHover {
  display: inline-block
}
</style>
